<template>
  <div v-show="accessPointCount > 1">
    <v-menu
      v-model="isMenuVisible"
      :persistent="false"
      :close-on-content-click="false"
      location="bottom"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          color="primary"
          elevation="0"
          block
          rounded="xl"
        >
          <v-icon>
            mdi-home-circle
          </v-icon>

          <span v-if="getActiveAP">
            {{ getActiveAP.node.name }}
          </span>
        </v-btn>
      </template>

      <v-list class="overflow-y-auto" style="max-height: 80vh;">
        <div v-for="tenant in sortedTenants" :key="tenant.id">
          <!-- Tenant Header -->
          <v-list-subheader>{{ tenant.name }}</v-list-subheader>

          <!-- Access Points for this tenant -->
          <v-list-item
            v-for="accessPoint in sortedAccesspoints(tenant)"
            :key="accessPoint.node.id"
            :disabled="accessPoint.node.id === getActiveAP?.node?.id"
            @click="setActiveAP(accessPoint)"
            class="pl-8"
          >
            <v-list-item-title>
              {{ accessPoint.node.name }}
            </v-list-item-title>
          </v-list-item>

          <!-- Divider between tenants -->
          <v-divider v-if="tenant.id !== sortedTenants[sortedTenants.length-1].id"></v-divider>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useUserStore } from '@/stores/UserStore.js'
import { useNodeStore } from '@/stores/NodeStore.js'
import { usePodStore } from '@/stores/PodStore.js';
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js';

export default {
  name: 'AccesspointSwitch',
  data() {
    return {
      isMenuVisible: false,
    };
  },
  methods: {
    async setActiveAP(accessPoint) {
      const nodeStore = useNodeStore();
      nodeStore.reset();

      const podStore = usePodStore();
      podStore.resetPods();

      const recycleBinStore = useRecycleBinStore();
      recycleBinStore.reset();

      const authStore = useAuthStore();
      authStore.setRootNodeId(accessPoint.node.id);

      this.isMenuVisible = false;

      if (this.$route.path.startsWith('/console')) {
        if (this.$route.path !== `/console/index`) {
          this.$router.push(`/console/index`);
        }

        return;
      }

      this.$router.push(`/node/${accessPoint.node.id}`);
    }
  },
  watch: {
    getActiveAP: {
      handler(accesspoint) {
        if (accesspoint) {
          this.$updateAbilities(accesspoint.group.abilities);
        } else {
          this.$updateAbilities([]);
        }

        if (this.$route.path.startsWith('/console')) {
          if (accesspoint) {
            const nodeStore = useNodeStore();
            nodeStore.setActiveNode(accesspoint.node.id);
          }

          const userStore = useUserStore();
          userStore.resetUsers()

          if (this.$canListUser()) {
            userStore.refreshUsers({ accessPointId: accesspoint?.node?.id });
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    getTenants() {
      const authStore = useAuthStore();
      return authStore.getTenants;
    },
    getActiveAP() {
      const authStore = useAuthStore();
      return authStore.getActiveAccesspoint;
    },
    sortedTenants() {
      // Create a copy of tenants and sort them by name
      const sortedTenants = [...this.getTenants].sort((a, b) =>
          a.name.localeCompare(b.name)
      );

      return sortedTenants;
    },
    sortedAccesspoints() {
      return function(tenant) {
        if (!tenant.accessPoints) {
          tenant.accessPoints = [];
        }

        return tenant.accessPoints
          .map((accessPoint) => {
            return {
              node: {
                id: accessPoint.node.id,
                name: accessPoint.node.name,
              },
            };
          })
          .sort((a, b) => {
            if (a.node && b.node) {
              return a.node.name.localeCompare(b.node.name);
            }
            if (!a.node && b.node) return 1;
            if (a.node && !b.node) return -1;
            return 0;
          });
      };
    },
    accessPointCount() {
      let count = 0;

      for (const tenant of this.getTenants) {
        if (tenant.accessPoints) {
          count += tenant.accessPoints.length;
        }
      }

      return count;
    }
  },
};
</script>

<style>
</style>
